"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CopyButton = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importStar(require("react"));
var SvgImage_1 = require("../../../../../components/SvgImage");
var CopySvg = function (_a) {
    var height = _a.height, width = _a.width;
    return react_1.default.createElement(SvgImage_1.SvgImage, { height: height, width: width, className: "social-share-icon", image: "sprites.svg#network-link-copy" });
};
var CopiedSvg = function (_a) {
    var height = _a.height, width = _a.width;
    return react_1.default.createElement(SvgImage_1.SvgImage, { height: height, width: width, className: "social-share-icon", image: "sprites.svg#network-link" });
};
exports.CopyButton = function (_a) {
    var height = _a.height, width = _a.width;
    var _b = react_1.useState(false), copied = _b[0], setCopied = _b[1];
    var buttonClick = react_1.useCallback(function () {
        if (copied) {
            return;
        }
        navigator.clipboard.writeText(window.location.href)
            .then(function () { return setCopied(true); });
    }, [copied]);
    return (react_1.default.createElement("button", { onClick: buttonClick, className: "c-social-share__item c-social-share__item--copy" }, copied ? react_1.default.createElement(CopiedSvg, { height: height, width: width }) : react_1.default.createElement(CopySvg, { height: height, width: width })));
};
